<template>
    <v-card class="pa-4">
        <v-card-title>API Eşleme</v-card-title>

        <v-card-text class="scrollable-text">

            <v-alert border="right" color="success" dark>
                ÖRNEK-1: Rest Api ile çekilen verilerden gelen verileri sisteme aktarabilirsiniz.<br>
                Yardım için lütfen dokümantasyonu inceleyiniz.<br>
                              <v-btn small outlined color="primary" @click="dialog = true" class="mr-2">
      Mapping Dökümantasyonu
    </v-btn>

            </v-alert>
            <v-row>
                <v-col>
                    <v-text-field v-model="apiUrl" label="API URL" append-outer-icon="mdi-send"
                        @click:append-outer="sendApi" outlined />

                    <v-text-field v-model="arrayPath" label="Liste Yolu" placeholder="data.items" persistent-hint
                        outlined
                        hint="Json verisindeki liste yolunu giriniz.ÖRN:Yukarıdaki json adresindeki data verisi => data" />

                    <v-text-field v-model="mapPath" label="Eşleme Alanı" placeholder="name" persistent-hint outlined
                        hint="Json verisindeki liste içerisinde almak istediğiniz alanı giriniz.ÖRN:Yukarıdaki json adresindeki data verisindeki attributes alanının name değeri =>  attributes.name" />

                    <v-btn color="primary" class="mt-3" :loading="loading" @click="fetchAndMap">
                        Veriyi Getir & Map Et
                    </v-btn>

                    <v-alert v-if="error" type="error" dense class="mt-3">
                        {{ error }}
                    </v-alert>

                    <v-list v-if="result.length" class="mt-4" max-height="350" height="350" style="overflow: auto;">
                        <v-subheader>Eşleme Sonuçu</v-subheader>
                        <v-list-item v-for="(item, index) in result" :key="index">
                            <v-list-item-content>
                                {{ item }}
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col col-sm="6" col-md="6" col-lg="6" col-xl="6">
                    <div style="height: 250px; overflow: scroll;width: 250px;">
                        <pre>
<code>
   {{ hamData }}
</code>
                        </pre>
                    </div>




                </v-col>
            </v-row>

        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="saveSelected">Seçilenleri Aktar</v-btn>
        </v-card-actions>
    <v-dialog v-model="dialog" max-width="950" scrollable>
      <v-card>
        <v-card-title class="headline">
          API JSON Veri Okuma Rehberi
        </v-card-title>

        <v-divider />

        <v-card-text>
          <!-- AMAÇ -->
          <h3>🎯 Amaç</h3>
          <p>
            Bir API adresinden dönen JSON veri içinden,
            belirli bir <b>liste</b> ve bu listenin içindeki
            <b>alan değerlerini</b> okumayı sağlar.
          </p>

          <!-- GERÇEK API -->
          <h3>🌐 Örnek API Adresi</h3>
          <pre>https://dogapi.dog/api/v2/breeds</pre>

          <p>
            Bu adres, köpek ırklarının bulunduğu bir veri listesi döndürür.
          </p>

          <!-- JSON YAPISI -->
          <h3>📦 API’den Dönen Veri (Özet)</h3>
          <pre>
{
  "data": [
    {
      "id": "036feed0",
      "attributes": {
        "name": "Affenpinscher",
        "life": {
          "min": 14,
          "max": 16
        }
      }
    }
  ]
}
          </pre>

          <!-- TEMEL KAVRAMLAR -->
          <h3>🧩 Temel Kavramlar</h3>

          <v-simple-table dense>
            <thead>
              <tr>
                <th>Kavram</th>
                <th>Açıklama</th>
                <th>Örnek</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>Liste Yolu</b></td>
                <td>
                  Veri içinde birden fazla kayıt içeren bölümün yoludur.
                </td>
                <td><code>data</code></td>
              </tr>
              <tr>
                <td><b>Alan Yolu</b></td>
                <td>
                  Listenin içindeki her kayıttan okunacak alanın yoludur.
                </td>
                <td><code>attributes.name</code></td>
              </tr>
            </tbody>
          </v-simple-table>

          <!-- NASIL OKUNUR -->
          <h3>📖 Nasıl Okunur?</h3>
          <ol>
            <li>Önce <b>Liste Yolu</b> bulunur</li>
            <li>Listenin içindeki her kayıt tek tek ele alınır</li>
            <li>Her kayıttan <b>Alan Yolu</b> ile değer okunur</li>
            <li>Okunan değerler yeni bir listeye eklenir</li>
          </ol>

          <!-- ÖRNEK 1 -->
          <h3>🧪 Örnek 1: Köpek Irkı İsimlerini Alma</h3>

          <v-simple-table dense>
            <tbody>
              <tr>
                <td>API Adresi</td>
                <td><code>https://dogapi.dog/api/v2/breeds</code></td>
              </tr>
              <tr>
                <td>Liste Yolu</td>
                <td><code>data</code></td>
              </tr>
              <tr>
                <td>Alan Yolu</td>
                <td><code>attributes.name</code></td>
              </tr>
            </tbody>
          </v-simple-table>

          <h4>📤 Sonuç</h4>
          <pre>
[
  "Affenpinscher",
  "Afghan Hound",
  "African Hunting Dog",
  "Airedale Terrier"
]
          </pre>

          <!-- ÖRNEK 2 -->
          <h3>🧪 Örnek 2: Maksimum Yaşam Süresi</h3>

          <v-simple-table dense>
            <tbody>
              <tr>
                <td>Liste Yolu</td>
                <td><code>data</code></td>
              </tr>
              <tr>
                <td>Alan Yolu</td>
                <td><code>attributes.life.max</code></td>
              </tr>
            </tbody>
          </v-simple-table>

          <h4>📤 Sonuç</h4>
          <pre>
[16, 15, 14, 13]
          </pre>

          <!-- HATALAR -->
          <h3>⚠️ Sık Yapılan Hatalar</h3>
          <ul>
            <li>
              <code>data.attributes.name</code> yazmak
              (Yanlış – çünkü <code>data</code> bir listedir)
            </li>
            <li>
              Liste olmayan bir alanı <b>Liste Yolu</b> olarak vermek
            </li>
            <li>
              Alan yolunda yanlış veya eksik tanım yapmak
            </li>
          </ul>

          <!-- DESTEK -->
          <h3>✅ Desteklenen Alan Yolu Formatları</h3>
          <ul>
            <li><code>attributes.name</code></li>
            <li><code>attributes.life.min</code></li>
            <li><code>attributes.life.max</code></li>
            <li><code>relationships.group.data.id</code></li>
          </ul>

          <p>
            Alan yolları <b>nokta (.)</b> ile okunur ve
            veri yapısı ne kadar iç içeyse yol da o kadar uzar.
          </p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="dialog = false">
            Kapat
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-card>
</template>

<script>
import axios from "axios";

export default {
    name: "ApiDataMapper",

    data() {
        return {
            hamData: [],
            apiUrl: "",
            arrayPath: "",
            mapPath: "",
            //        arrayPath: "data",
            // mapPath: "attributes.name",
            mappedResult: [],
            loading: false,
            error: null, result: [],
            dialog:false
        };
    },

    methods: {
        async sendApi() {
            const response = await axios.get(this.apiUrl, { withCredentials: false });
            if (response.status == 200) {
                this.hamData = response.data;
            }
            else {
                this.hamData = [];
            }
        },
        async fetchAndMap() {
            this.loading = true;
            this.error = null;
            this.result = [];

            try {
               let arrayData=[];
                const res = await axios.get(this.apiUrl, { withCredentials: false });
                if (this.arrayPath) {
                   arrayData = this.getValueByPath(res.data, this.arrayPath);
                }
                else
                {
                     arrayData = res.data;
                }

               /*     if (!arrayData) {
                    throw new Error("Liste Yolu bulunamadı");
                }


            if (!Array.isArray(arrayData)) {
                    throw new Error("Liste Yolu bir liste değil");
                }*/
console.log("Arraydata:",arrayData);
                this.result = arrayData
                    .map(item => this.getValueByPath(item, this.mapPath))
                    .filter(v => v !== undefined && v !== null);
             

            } catch (e) {
                this.error = e.message;
            } finally {
                this.loading = false;
            }
        },

        getValueByPath(obj, path) {
            return path
                .replace(/\[(\w+)\]/g, ".$1")
                .split(".")
                .reduce((acc, key) => acc && acc[key], obj);
        },




        saveSelected() {
            this.$emit("selectedChange", this.result);
        }
    }
};
</script>
<style scoped>
.scrollable-text {
  max-height: 500px;   /* istediğiniz sabit yükseklik */
  overflow-y: auto;    /* dikey scroll */
}
</style>




<!-- <template>
    <div>
        <v-text-field v-model="txtUrl" label="Url"></v-text-field>
        <v-text-field v-model="txtModel" label="Model"></v-text-field>
        <v-btn color="success" @click="ara">Ara</v-btn>

<p>gdfgdfgdf</p>
{{ cevap }}
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {

        return {
            txtUrl: "",
            txtModel: "",
            sonuc:"",
            cevap:""
        };
    },
    methods: {
        ara() {
            let cevap="";
            axios.get('https://dogapi.dog/api/v2/breeds', { withCredentials: false }).then((result) => {
                console.log("fsdfsd", result);
                this.sonuc=result.data;
                if (Array.isArray(result.data)) {
                    console.log("Array");
                    this.cevap=  result.data.map(item => item[this.txtModel]);
                }
                else
                {
                  
                    this.cevap=  result.data[this.txtModel.toString()]; 
                     console.log("object",result.data["id"]);
                }
             
            }).catch((err) => {
 console.log("fsdfsd", err);
            });
        },
        propMapper(prop) {
            item => item[prop];
        } 

    }
}
</script> -->
